import React, { useEffect } from 'react';
import SessionSummary from './SessionSummary';
import './SlideUpDrawer.css';

export default function SlideUpDrawer({ isOpen, onClose, chatId }) {

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };


  if (!isOpen) return null;

  return (
    <div className="drawer-overlay" onClick={handleOverlayClick}>
      <div className={`slide-up-drawer ${isOpen ? 'open' : ''}`}>
        <div className="drawer-handle"></div>
        <div className="drawer-content">
          <SessionSummary chatId={chatId} />
        </div>
      </div>
    </div>
  );
}